import { Component, Renderer } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { AbstractFormComponent } from '../../../../core/abstract-form-component';
import { createDialogValidationMessages, getCreateDialogControlsConfig } from './create.dialog.form';
import { CreateDialogStateService } from './create.dialog.communications.state.service';
import { CommunicationsHttpService } from '../../../../services/communications/communications.http.service';
import { StorageUtil } from '../../../../utils/storage.util';
import { CommunicationsHttpUtil } from '../communications.util';
import { CommunicationsStateService } from '../communications.state.service';
import { AuthUtil } from '../../../../utils/auth.utils';

@Component({
  moduleId: module.id,
  selector: 'bft-create-dialog',
  templateUrl: 'create.dialog.communications.component.html',
  styleUrls: ['create.dialog.communications.component.css'],
  providers: []
})

export class CreateDialogCommunicationsComponent extends AbstractFormComponent {

  chatTypeList = [{label: 'Вопрос администратору', value: '0'}, {label: 'Общий вопрос', value: '2'}];
  model = {
    chatType: this.chatTypeList[0].value,
    chatTheme: '',
    chatMessage: '',
    lawInstanceId: '0',
  };
  attachment;
  displayDialog: boolean = false;
  loading: boolean = false;
  errorMessage = '';
  successMessage = '';

  isAttached = false;

  constructor(private createDialogStateService: CreateDialogStateService,
              private formBuilder: FormBuilder,
              private communicationsHttpService: CommunicationsHttpService,
              private communicationsStateService: CommunicationsStateService,
              private authUtil: AuthUtil,
              private renderer: Renderer,
  ) {
    super();

    this.createDialogStateService.handleDialogStatus().subscribe(data => {
      this.displayDialog = data.display;
      this.isAttached = false;
      this.attachment = '';
      this.errorMessage = '';
      this.form.reset();
      this.model = {
        chatType: this.chatTypeList[0].value,
        chatTheme: '',
        chatMessage: '',
        lawInstanceId: '0',
      };
      this.form.patchValue(this.model);
    });

  }

  buildForm(): FormGroup {
    return this.formBuilder.group(getCreateDialogControlsConfig(this.model, this.formBuilder));
  }

  getValidationMessages(): {} {
    return createDialogValidationMessages;
  }

  submit() {
    this.loading = true;
    delete this.errorMessage;
    delete this.successMessage;

    let data = {
      securityToken: StorageUtil.getToken(),
      chatType: this.form.value.chatType,
      chatTheme: this.form.value.chatTheme,
      chatMessage: this.form.value.chatMessage,
      lawInstanceId: this.model.lawInstanceId,
      attachment: this.attachment,
    };

    let requestParams = CommunicationsHttpUtil.prepareParamsCreateDialog(data);
    this.communicationsHttpService.createChat(requestParams).subscribe(
      success => {
        if (success) {
          this.loading = false;
          // if(success.json().response) {
            // let chatId = +success.json().response.$;

            this.communicationsStateService.triggerNewQuest({
              // id: chatId,
              chatType: data.chatType,
              chatTheme: data.chatTheme,
            });
            this.displayDialog = false;
            this.isAttached = false;
            this.attachment = '';
          // }

          this.authUtil.checkErrorResponse(success.json());
          window.location.reload();
        }
      },
      error => {
        this.errorMessage = 'Произошла ошибка.';
        this.loading = false;
      },
      () => {
        this.loading = false;
      });
  }

  close($event) {
    $event.preventDefault();
    this.displayDialog = false;
    this.attachment = '';
  }

  triggerSetAttachment($event) {
    this.isAttached = !!$event.attachment;
    this.attachment = $event.attachment;
  }

  findAncestor (el, cls) {
    while ((el = el.parentElement) && !el.classList.contains(cls));
    return el;
  }

  onClick($event) {
    let element = this.findAncestor($event.target, 'topic-hold');
    if(element) {
      if(element.classList.contains('focus') ) {
        this.renderer.setElementClass(element, 'focus', false);
      } else {
        this.renderer.setElementClass(element, 'focus', true);
      }
    }

  }

  onFocus($event) {
    let element = this.findAncestor($event.target, 'topic-hold');
    this.renderer.setElementClass(element, 'focus', true);
  }

  onBlur($event) {
    let element = this.findAncestor($event.target, 'topic-hold');
    this.renderer.setElementClass(element, 'focus', false);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/communications/create-dialog-communications/create.dialog.communications.component.ts